import axiosWithToken from '@/api/axios'
import { adminRoot } from '@/constants/config'
import { adminBaseUrl } from '@/store'
import { postMethodConfig } from '@/api/axios'

const state = () => ({
  pages: [],
  isLoading: false
})

const getters = {
  pages: (state) => state.pages,
  isLoading: (state) => state.isLoading
}

const mutations = {
  SET_PAGES(state, payload) {
    state.pages = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  fetchPages({ commit, dispatch }, { vm }) {
    commit('SET_LOADING', true)
    axiosWithToken
      .get(vm.apiUrl)
      .then((res) => {
        const message = res.data.message
        commit('SET_PAGES', message.data)
        vm.page = message.current_page
        vm.perPage = message.per_page
        vm.numberOfPages = message.last_page
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  createSinglePage({ dispatch }, { payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }

    axiosWithToken
      .post(`${adminBaseUrl}/pages`, data, postMethodConfig)
      .then(() => {
        vm.$router.push('/admin/pages')
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
  },
  deleteSinglePage(_context, { id, vm }) {
    axiosWithToken
      .delete(`${adminBaseUrl}/pages/${id}`)
      .then(() => {
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
  },
  fetchSinglePage(_context, { id, vm }) {
    vm.isLoading = true
    axiosWithToken
      .get(`${adminBaseUrl}/pages/${id}`)
      .then((res) => {
        const message = res.data.message
        vm.editForm.title_en = message.title_en
        vm.editForm.title_ru = message.title_ru
        vm.editForm.content_en = message.content_en
        vm.editForm.content_ru = message.content_ru
        vm.imageUrl = message.image
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        setTimeout(() => {
          vm.isLoading = false
        }, 1000)
      })
  },
  updateSinglePage(_context, { payload, id, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    data.append('_method', 'PUT')

    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/pages/${id}`, data, postMethodConfig)
      .then(() => {
        vm.$router.push(`${adminRoot}/pages`)
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
